<p class= "break-word m-sm">{{addressValidationMessage}}</p>
<p class="break-word m-sm">{{instructionalText}}</p>
<div *ngIf='addressCorrected' class="row">
  <div class="addressMargin" *ngIf ="show.suggestedAddress">
    <p>
      <strong>Suggested Address</strong>
    </p>
    <button id="address_validation_SuggestedAddress" mat-button class="nsc-button addressButton" type="button" (click)="dialogRef.close(correctedAddressValues)">
      {{ correctedAddressValues.delivery_line_1 || correctedAddressValues.address1}}
      <br *ngIf="correctedAddressValues.delivery_line_2 || correctedAddressValues.address2">
      {{correctedAddressValues.delivery_line_2 || correctedAddressValues.address2 }}
      <br>
      {{correctedAddressValues.components.city_name || correctedAddressValues.components.locality }},{{correctedAddressValues.components.state_abbreviation || correctedAddressValues.components.administrative_area}}
      {{ correctedAddressValues.components.postal_code || (correctedAddressValues.components.zipcode + (correctedAddressValues.components.plus4_code ? ('-' + correctedAddressValues.components.plus4_code) : ''))}}
    </button>
  </div>

  <div class="addressMargin" *ngIf="show.suggestedAddress && continueOnlyWithValidAddress">
      
        <strong>Entered Address</strong><br>
        <p class="m-sm">
        {{enteredAddress.request.street}} <br *ngIf="!isNullorBlank(enteredAddress.request.street2)">
        {{enteredAddress.request.street2}} <br>
        {{enteredAddress.request.city}} {{enteredAddress.request.state}} {{enteredAddress.request.zipcode}}</p>
  </div>

  <nsc-spacer size="sm"></nsc-spacer>
  <div *ngIf="show.suggestedAddress && show.enteredAddress">
      <p>
          <strong>Entered Address</strong>
        </p>
      <button id="address_validation_EnteredAddress" mat-button class="nsc-button addressButton" type="button" (click)="dialogRef.close(enteredAddress)">
          {{enteredAddress.request.street}} <br *ngIf="!isNullorBlank(enteredAddress.request.street2)">
          {{enteredAddress.request.street2}} <br>
          {{enteredAddress.request.city}} {{enteredAddress.request.state}} {{enteredAddress.request.zipcode}}
      </button> 
  </div>
</div>
<div *ngIf="!addressCorrected && show.enteredAddress && !missingSecondary">
    <nsc-spacer size="sm"></nsc-spacer>
    
      <strong>Entered Address</strong><br>
      <p class="m-sm">
      {{enteredAddress.request.street}} <br *ngIf="!isNullorBlank(enteredAddress.request.street2)">
      {{enteredAddress.request.street2}} <br>
      {{enteredAddress.request.city}} {{enteredAddress.request.state}} {{enteredAddress.request.zipcode}} </p>
</div>
<div *ngIf='missingSecondary'>
  <mat-form-field>
    <input id="address_validation_change_apt" matInput [(ngModel)]='secondaryNbr' placeholder="Correct your Apt/Suite Number">
  </mat-form-field>
  <button id="address_validation_submit" [disabled]="!secondaryNbr" mat-button class="nsc-button" type="button" [mat-dialog-close]='secondaryNbr'
    cdkFocusInitial>Submit</button>
</div>
<nsc-spacer size="sm"></nsc-spacer>
<button id="address_validation_change_suggested" *ngIf="show.suggestedAddress && continueOnlyWithValidAddress" mat-button class="nsc-button" type="button" 
        (click)="dialogRef.close(false)">Edit Address</button>
<div *ngIf='!addressCorrected' class=mat-dialog-actions>
  <button mat-button id="address_validation_EditAddress" class="nsc-button" type="button" (click)="dialogRef.close(false)">Edit Address</button>
  <button mat-button id="address_validation_use_entered" class="nsc-button" type="button" (click)="dialogRef.close(true)">Use Entered Address</button>
</div>